import { render, staticRenderFns } from "./ResumenCompraComponent.vue?vue&type=template&id=3e2fa9c0&scoped=true"
import script from "./ResumenCompraComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumenCompraComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResumenCompraComponent.vue?vue&type=style&index=0&id=3e2fa9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2fa9c0",
  null
  
)

export default component.exports